import {setOrFallbackValue} from './helper';
export class Shipment {
    constructor(props) {
        this.priority = setOrFallbackValue(props, 'priority', null);
        this.amount = setOrFallbackValue(props, 'amount', null);
        this.itemsQtyTotal = setOrFallbackValue(props, 'itemsQtyTotal', null);
        this.eta = (null === setOrFallbackValue(props, 'eta', null)) ?
            {} : new ShipmentEta(props.eta);
        this.shippingTime = (null === setOrFallbackValue(props, 'shippingTime', null)) ?
            {} : new ShippingTime(props.shippingTime);
        this.fromAddress = (null === setOrFallbackValue(props, 'fromAddress', null)) ?
            {} : new FromAddress(props.fromAddress);
        this.toAddress = (null === setOrFallbackValue(props, 'toAddress', null)) ?
            {} : new ToAddress(props.toAddress);
        this.items = (null === setOrFallbackValue(props, 'items', null)) ?
            [] : props.items.map((item) => {return new Item(item);});
    }
}

export class ShippingSummary {
    constructor(props) {
        this.priority = setOrFallbackValue(props, 'priority', null);
        this.amount = setOrFallbackValue(props, 'amount', null);
        this.eta = (null === setOrFallbackValue(props, 'eta', null)) ?
            {} : new ShipmentEta(props.eta);
        this.shippingTime = (null === setOrFallbackValue(props, 'shippingTime', null)) ?
            {} : new ShippingTime(props.shippingTime);
    }
}

class ShipmentEta {
    constructor(eta) {
        this.etaFrom = setOrFallbackValue(eta, 'etaFrom', null);
        this.etaTo = setOrFallbackValue(eta, 'etaTo', null);
        this.predictedEta = setOrFallbackValue(eta, 'predictedEta', null);
        this.deliveryInterval = setOrFallbackValue(eta, 'deliveryInterval', null);
        this.confirmedEta = setOrFallbackValue(eta, 'confirmedEta', null);
    }
}

class ShippingTime {
    constructor(shippingTime) {
        this.daysFrom = setOrFallbackValue(shippingTime, 'daysFrom', null);
        this.daysTo = setOrFallbackValue(shippingTime, 'daysTo', null);
    }
}

class FromAddress {
    constructor(fromAddress) {
        this.state = setOrFallbackValue(fromAddress, 'state', null);
    }
}

class ToAddress extends FromAddress {
    constructor(toAddress) {
        super(toAddress);
        this.postcode = setOrFallbackValue(toAddress, 'postcode', null);
    }
}

class Item {
    constructor(item) {
        this.qty = setOrFallbackValue(item, 'qty', null);
        this.productCode = setOrFallbackValue(item, 'productCode', null);
    }
}
